import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { API_BASE_URL } from "../../config";
import axios from "axios";
import { toast } from "react-toastify";

const AddCompanyProfile = () => {
  const [formData, setFormData] = useState({
    email: "",
    mobile: "",
    address: "",
    email_to: "",
    reply_to: "",
    copy_right: "",
    app_store_link: "",
    play_store_link: "",
    body_script: "",
    head_script: "",
  });

  const {
    email,
    mobile,
    address,
    email_to,
    reply_to,
    copy_right,
    app_store_link,
    play_store_link,
    body_script,
    head_script,
  } = formData;

  const [pageError, setPageError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [imageError, setImageError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [shortOrderError, setShortOrderError] = useState("");
  const [linkError, setLinkError] = useState("");
  const [servicesError, setServicesError] = useState("");
  const [shownInError, setShownInError] = useState("");

  const [addressError, setAddressError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [emailToError, setEmailToError] = useState("");
  const [replyToError, setReplyToError] = useState("");
  const [copyrightError, setCopyrightError] = useState("");
  const [playStoreError, setPlayStoreError] = useState("");
  const [appStoreError, setAppStoreError] = useState("");
  const [headScriptError, setHeadScriptError] = useState("");
  const [bodyScriptError, setBodyScriptError] = useState("");

  const [imagePreview, setImagePreview] = useState(null);
  const [image, setImage] = useState();
  const [managePageData, setManagePageData] = useState();
  const [token, setToken] = useState(localStorage.getItem("token"));

  const navigate = useNavigate();

  const { id } = useParams();

  let hasError = false;

  useEffect(() => {
    setToken(localStorage.getItem("token"));
    if (id) {
      ViewCompanyProfile();
    }
  }, []);

  const handleEditorChangeDescription = (content, editor) => {
    setFormData({ ...formData, description: content });
  };

  const ViewCompanyProfile = async () => {
    const res = await axios.get(`${API_BASE_URL}/view-company-profile/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(res, "res");
    if (res.data.status == 200) {
      setFormData({
        ...formData,
        email: res.data.result.email,
        mobile: res.data.result.mobile,
        address: res.data.result.address,
        email_to: res.data.result.email_to,
        reply_to: res.data.result.reply_to,
        copy_right: res.data.result.copy_right,
        app_store_link: res.data.result.app_store_link,
        play_store_link: res.data.result.play_store_link,
        body_script: res.data.result.body_script,
        head_script: res.data.result.head_script,
      });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(formData, "form");

    if (!formData.email) {
      setEmailError("Please Enter Email ");
      hasError = true;
    } else {
      setEmailError("");
    }
    if (!formData.mobile) {
      setMobileError("Please enter mobile no.");
      hasError = true;
    } else {
      setMobileError("");
    }
    if (!formData.address) {
      hasError = true;
      setAddressError("Please enter address");
    } else {
      setAddressError("");
    }
    if (!formData.email_to) {
      setEmailToError("Please enter  ");
      hasError = true;
    } else {
      setEmailToError("");
    }

    if (!formData.reply_to) {
      setReplyToError("Please enter");
      hasError = true;
    } else {
      setReplyToError("");
    }

    if (!formData.play_store_link) {
      setPlayStoreError("Please enter play store link");
      hasError = true;
    } else {
      setPlayStoreError("");
    }

    if (!formData.app_store_link) {
      setAppStoreError("Please enter app store link  ");
      hasError = true;
    } else {
      setAppStoreError("");
    }

    if (!formData.reply_to) {
      setReplyToError("Please enter");
      hasError = true;
    } else {
      setReplyToError("");
    }

    if (!hasError) {
      axios
        .post(`${API_BASE_URL}/add-company-profile`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          console.log(response.data.status);
          if (response.data.status === 200) {
            navigate("/crm/managecompanyprofile");
            toast.success("Added successfully");
          }
        })
        .catch((error) => {
          setPageError(error.response.data.result);
          console.log(error);
        });
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Add Company </h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="javascript: void(0);">CMS</a>
                      </li>
                      <li className="breadcrumb-item ">
                        <Link to={"/crm/managecompanyprofile"}>
                          Manage Company
                        </Link>
                      </li>

                      <li className="breadcrumb-item active">Add Company</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title mb-4">Add Company</h4>
                      <form onSubmit={handleSubmit}>
                        <div data-repeater-list="outer-group" className="outer">
                          <div data-repeater-item className="outer">
                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                Email
                              </label>
                              <div className="col-lg-10">
                                <input
                                  id="email"
                                  name="email"
                                  type="text"
                                  value={email}
                                  className={
                                    emailError
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter Email"
                                  onChange={handleInputChange}
                                />
                                {emailError && (
                                  <div className="text-danger">
                                    {emailError}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                Mobile
                              </label>
                              <div className="col-lg-10">
                                <input
                                  id="mobile"
                                  name="mobile"
                                  type="text"
                                  value={mobile}
                                  className={
                                    mobileError
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter Mobile No."
                                  onChange={handleInputChange}
                                />
                                {mobileError && (
                                  <div className="text-danger">
                                    {mobileError}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                Address
                              </label>
                              <div className="col-lg-10">
                                <input
                                  id="address"
                                  name="address"
                                  type="text"
                                  value={address}
                                  className={
                                    addressError
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter Address"
                                  onChange={handleInputChange}
                                />
                                {addressError && (
                                  <div className="text-danger">
                                    {addressError}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                Email To
                              </label>
                              <div className="col-lg-10">
                                <input
                                  id="email_to"
                                  name="email_to"
                                  type="text"
                                  value={email_to}
                                  className={
                                    emailToError
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter Email To"
                                  onChange={handleInputChange}
                                />
                                {emailToError && (
                                  <div className="text-danger">
                                    {emailToError}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                Reply To
                              </label>
                              <div className="col-lg-10">
                                <input
                                  id="reply_to"
                                  name="reply_to"
                                  type="text"
                                  value={reply_to}
                                  className={
                                    replyToError
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter Reply To"
                                  onChange={handleInputChange}
                                />
                                {replyToError && (
                                  <div className="text-danger">
                                    {replyToError}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                Copyright
                              </label>
                              <div className="col-lg-10">
                                <input
                                  id="copy_right"
                                  name="copy_right"
                                  type="text"
                                  value={copy_right}
                                  className={
                                    copyrightError
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter Copyright"
                                  onChange={handleInputChange}
                                />
                                {copyrightError && (
                                  <div className="text-danger">
                                    {copyrightError}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                Play Store Link
                              </label>
                              <div className="col-lg-10">
                                <input
                                  id="play_store_link"
                                  name="play_store_link"
                                  type="text"
                                  value={play_store_link}
                                  className={
                                    playStoreError
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter play store link"
                                  onChange={handleInputChange}
                                />
                                {playStoreError && (
                                  <div className="text-danger">
                                    {playStoreError}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                App Store Link
                              </label>
                              <div className="col-lg-10">
                                <input
                                  id="app_store_link"
                                  name="app_store_link"
                                  type="text"
                                  value={app_store_link}
                                  className={
                                    appStoreError
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter app store link"
                                  onChange={handleInputChange}
                                />
                                {appStoreError && (
                                  <div className="text-danger">
                                    {appStoreError}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                Head Script
                              </label>
                              <div className="col-lg-10">
                                <textarea
                                  id="app_store_link"
                                  name="head_script"
                                  value={head_script}
                                  rows={5}
                                  type="text"
                                  className={
                                    headScriptError
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter Head Script"
                                  onChange={handleInputChange}
                                />
                                {headScriptError && (
                                  <div className="text-danger">
                                    {headScriptError}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                Body Script
                              </label>
                              <div className="col-lg-10">
                                <textarea
                                  id="body_script"
                                  name="body_script"
                                  rows={5}
                                  type="text"
                                  value={body_script}
                                  className={
                                    bodyScriptError
                                      ? "form-control is-invalid"
                                      : "form-control "
                                  }
                                  placeholder="Enter Body Script"
                                  onChange={handleInputChange}
                                />
                                {bodyScriptError && (
                                  <div className="text-danger">
                                    {bodyScriptError}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row justify-content-end">
                          <div className="col-lg-10">
                            {pageError && (
                              <div className="alert alert-danger" role="alert">
                                {pageError}
                              </div>
                            )}
                            <button type="submit" className="btn btn-primary">
                              Add Company
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCompanyProfile;
